<template>
  <div
    class="ProductDetails"
    v-if="ProductDetailsFlag && this.$store.state.discount > 0"
  >
    <div
      class="selectProductContentBox"
      :style="{ width: this.$store.state.PCFlag ? '11.04rem' : '' }"
      v-show="selectProductFlag"
    >
      <div class="selectProductMask" @click="addShoppingCartPopup"></div>
      <div class="selectProductContent">
        <div class="shutIcon" @click="addShoppingCartPopup">
          <img src="../../assets/images/updataFile/shutIcon.png" />
        </div>
        <div class="selectProductCoverAndPrice">
          <img class="ProductCover" :src="coverArr[0]" />
          <div class="price">
            <span>￥</span>
            <span>{{
              allPrice == 0
                ? calculationDiscount(productDetails.salePrice)
                : calculationDiscount(allPrice)
            }}</span>
          </div>
        </div>
        <div class="TestItems">
          <div class="TestItemsTitle">检测项目</div>
          <div class="TestItemsList">
            <div
              :class="{ TestItemsItem: true, active: item.active }"
              @click="
                selectTestItemsItemId(
                  item.id,
                  item.active,
                  index,
                  item.salePrice
                )
              "
              v-for="(item, index) in TestItemsList"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
        <div class="addShoppingCart" @click="addShoppingCart">
          <div class="txt">加入已选项</div>
        </div>
      </div>
    </div>
    <!-- 产品详情 -->
    <div class="productBanner">
      <img v-for="item in coverArr" :src="item" :key="item" />
    </div>
    <div class="productInfo">
      <div style="display: flex; align-items: baseline">
        <div class="product-price">
          <span>￥</span>
          <span>{{ calculationDiscount(productDetails.salePrice) }}</span>
        </div>
        <div
          style="text-decoration: line-through; color: #aaa; margin-left: 10px"
          v-if="$store.state.discount < 100"
        >
          ¥{{ productDetails.salePrice }}
        </div>
      </div>
      <div class="product-name">{{ productDetails.name }}</div>
    </div>
    <div class="selectProduct" @click="addShoppingCartPopup">
      <div class="txt">选择检测项目</div>
      <img
        class="arrow"
        src="../../assets/images/updataFile/arrow-right-icon.png"
      />
    </div>
    <div class="details">
      <div class="title">项目详情</div>
      <img
        class="productDetailsImg"
        v-for="item in productDetailsImageArr"
        :src="item"
        :key="item"
      />
    </div>
    <!-- 底部客服及支付 -->
    <div
      class="bottom-content"
      :style="{ width: this.$store.state.PCFlag ? '11.04rem' : '' }"
    >
      <div class="monery">
        <div class="presentPrice">
          <span>￥</span>
          <span>{{ calculationDiscount(productDetails.salePrice) }}</span>
        </div>
      </div>
      <div class="addShoppingCart" @click="addShoppingCartPopup">
        加入已选项
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
export default {
  data() {
    return {
      productDetails: {},
      ProductDetailsFlag: false,
      selectProductFlag: false,
      selectProductInfo: {},
      productId: "",
      TestItemsList: [],
      productDetailsImageArr: [],
      coverArr: [],
      allPrice: 0,
    };
  },
  created() {
    let query = this.$route.query;
    if (query.doctorId) localStorage.setItem("doctorId", query.doctorId);
    this.getProductDetails(query.id, query.productId);
    this.getAllProductInfo(query.productId, query.id);
    this.productId = query.id;
    if (localStorage.getItem("userInfo")) this.$getShoppingNumber();
    if (!this.$store.state.wxConfigFlag) this.$wxConfig();
  },
  methods: {
    // 选择检测项
    selectTestItemsItemId(id, active, index, salePrice) {
      let list = this.TestItemsList;
      if (list[index].active) {
        list[index].active = false;
        this.allPrice -= salePrice;
      } else {
        list[index].active = true;
        this.allPrice += salePrice;
      }
      this.TestItemsList = list;
      this.$forceUpdate();
    },
    /**
     *出现加载中的时候不让滚动
     */
    touchstartReturn() {
      return;
    },
    /* 根据产品id查询产品信息 */
    getProductDetails(id, productId) {
      if (productId != 0) id = productId;
      this.$http.get(`/product/baseControllerGetById/${id}`).then((res) => {
        if (res.data.code == 200) {
          this.$store.state.loadingFlag = false;
          let data = res.data.data;
          this.$store.state.title = data.productName || data.name;
          if (data.cover) this.coverArr = data.cover.split(",");
          if (data.productDetailsImage)
            this.productDetailsImageArr = data.productDetailsImage.split(",");
          this.productDetails = data;
          this.ProductDetailsFlag = true;
        }
      });
    },
    getAllProductInfo(productId, id) {
      this.$http
        .get(`/product/getUserProduct`, {
          params: { ProductId: productId == 0 ? id : productId, size: 100 },
        })
        .then((res) => {
          if (res.data.code == 200) {
            let data = res.data.data;
            let list = data.records;
            for (let i = 0; i < list.length; i++) {
              if (list[i].id == this.productId) {
                list[i].active = true;
                this.allPrice += list[i].salePrice;
              }
            }
            this.TestItemsList = list;
          }
        });
    },
    /* 加入已选项 */
    addShoppingCartPopup() {
      if (!this.selectProductFlag) document.body.className = "overflow";
      else document.body.className = "";
      this.selectProductFlag = !this.selectProductFlag;
    },
    addShoppingCart() {
      if (localStorage.getItem("userInfo")) {
        if (this.$store.state.closureFlag) {
          this.$store.state.closureFlag = false;
          let TestItemsList = this.TestItemsList;
          let list = [];
          let userId = JSON.parse(localStorage.getItem("userInfo")).id;
          for (let i = 0; i < TestItemsList.length; i++) {
            let item = TestItemsList[i];
            if (item.active)
              list.push({
                productId: item.id,
                userId: userId,
                total: 1,
                doctorId: localStorage.getItem("doctorId"),
              });
          }
          if (list.length == 0) this.$toots("请选择产品");
          else {
            this.$loading("加入中");
            this.$http
              .post(
                // `/shoppingCart/saveShoppingCart`,
                `/shoppingCart/batchSaveShoppingCart`,
                list,
                {
                  qs: "no",
                }
              )
              .then((res) => {
                this.addShoppingCartPopup();
                if (res.data.code == 200) {
                  this.$tootsSuccess("已加入");
                  this.$getShoppingNumber();
                } else if (res.data.code == 400) this.$toots(res.data.msg);
                else this.$toots("系统正在升级，请稍后");
              })
              .catch((err) => {
                this.$toots("系统正在升级，请稍后");
              });
          }
        }
      } else {
        this.$goLogin();
      }
    },
  },
};
</script>
<style lang="less">
.ProductDetails {
  padding-bottom: 137px;
  background-color: #f5f5f5;
  .productBanner {
    img {
      width: 100%;
      display: block;
    }
  }
  .productInfo {
    padding-top: 10px;
    background-color: #fff;
    padding-left: 30px;
    padding-right: 30px;
    .product-name {
      font-size: 36px;
      line-height: 52px;
      font-weight: 700;
      padding-top: 20px;
      padding-bottom: 20px;
    }
    .product-price {
      padding-top: 10px;
      right: 30px;
      color: #ef2538;
      font-weight: 700;
      span:first-child {
        font-size: 30px;
      }
      span:last-child {
        font-size: 46px;
      }
    }
  }
  .selectProduct {
    padding-left: 30px;
    padding-right: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    margin-top: 20px;
    padding-top: 20px;
    padding-bottom: 20px;
    line-height: 50px;
    font-size: 34px;
    .arrow {
      width: 14px;
      height: 24px;
    }
    .txt {
      color: #ff0000a8;
    }
  }
  /* 项目详情使用富文本 */
  .details {
    margin-top: 20px;
    background-color: #fff;
    .title {
      height: 112px;
      line-height: 112px;
      border-bottom: 1px solid #eee;
      padding-left: 50px;
      font-size: 34px;
      position: relative;
    }
    .title::after {
      content: "";
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 30px;
      width: 6px;
      height: 30px;
      background-color: #1968a8;
    }
    .details-info {
      padding: 20px 30px 50px 30px;
      text-align: justify;
      p {
        font-size: 30px;
        line-height: 50px;
      }
      img {
        width: 100%;
        display: block;
      }
    }
    .productDetailsImg {
      width: 100%;
      display: block;
    }
  }

  .selectProductContentBox {
    position: fixed;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    height: 100%;
    z-index: 11;
    .selectProductMask {
      background-color: rgba(0, 0, 0, 0.5);
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    .selectProductContent {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      overflow: auto;
      padding-top: 50px;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      background-color: #fff;
      max-height: 80%;
      display: flex;
      flex-direction: column;
      .shutIcon {
        position: absolute;
        right: 0px;
        top: 50px;
        width: 100px;
        height: 100px;
        text-align: center;
        img {
          width: 26px;
          height: 26px;
        }
      }
      .selectProductCoverAndPrice {
        padding-left: 30px;
        padding-right: 30px;
        display: flex;
        justify-content: space-between;
        align-content: center;
        .ProductCover {
          width: 180px;
          height: 130px;
          display: block;
          border-radius: 10px;
        }
        .price {
          flex: 1;
          padding-left: 30px;
          line-height: 130px;
          color: #ef2538;
          font-weight: 700;
          span:first-child {
            font-size: 30px;
          }
          span:last-child {
            font-size: 46px;
          }
        }
      }
      .TestItems {
        padding-left: 30px;
        padding-right: 30px;
        padding-bottom: 98px;
        margin-bottom: 30px;
        margin-top: 40px;
        .TestItemsTitle {
          font-size: 28px;
          line-height: 40px;
          margin-bottom: 20px;
          color: #999999;
        }
        .TestItemsList {
          display: flex;
          flex-wrap: wrap;
          pointer-events: auto;
          max-height: 500px;
          overflow: auto;
          margin-bottom: 30px;
          .TestItemsItem {
            font-size: 28px;
            padding: 10px 30px;
            line-height: 48px;
            border-radius: 62px;
            background-color: #f4f4f4;
            display: inline-block;
            margin-bottom: 30px;
            margin-right: 20px;
          }
          .TestItemsItem.active {
            color: #fff;
            background-color: #1968a8;
          }
        }
      }

      .addShoppingCart {
        .txt {
          background-color: #1968a8;
          font-size: 32px;
          height: 98px;
          line-height: 98px;
          color: #fff;
          text-align: center;
        }
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        padding-bottom: env(safe-area-inset-bottom);
        padding-bottom: constant(safe-area-inset-bottom);
      }
    }
  }
}
</style>

